import { z } from "zod";
const baseToolPostPayloadSchema = z.object({
  type: z.string().nonempty(),
  name: z.string().nonempty(),
  description: z.string().nonempty(),
  settings: z.any()
});
const baseToolPatchPayloadSchema = z.object({
  type: z.string().nonempty(),
  name: z.string().nonempty().optional(),
  description: z.string().nonempty().optional(),
  settings: z.any().optional()
});
export {
  baseToolPatchPayloadSchema,
  baseToolPostPayloadSchema
};
//# sourceMappingURL=base.js.map
